// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"TheNav_navIcon_2dNWh","logo":"TheNav_logo_HJLOI","img":"TheNav_img_1ci1u"};